export default [
  'http://localhost:8000',
  'http://localhost:8080',
  'http://widgets.staging.resy.com',
  'https://widgets.staging.resy.com',
  'http://staging-widgets.resy.com',
  'https://staging-widgets.resy.com',
  'http://widgets.demo.resy.com',
  'https://widgets.demo.resy.com',
  'http://demo-widgets.resy.com',
  'https://demo-widgets.resy.com',
  'http://widgets.dev.resy.com',
  'https://widgets.dev.resy.com',
  'http://widgets.resy.com',
  'https://widgets.resy.com',
];
